import React from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import DashboardIcon from '@material-ui/icons/Dashboard';
import LocalLibraryIcon from '@material-ui/icons/Book';
import PeopleIcon from '@material-ui/icons/People';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import AppsIcon from '@material-ui/icons/Apps';
import { t } from 'ttag';
import { makeStyles } from '@material-ui/core/styles';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import useReactRouter from 'use-react-router';
import { useNavigator } from '../Navigator';
import { SECTION_MAP, useMenuState } from '../MenuList/provider';
import router from '../../api/router';
import { canViewContributions, canViewDankai } from '../../utils/permissions';
import useUser from '../../auth/hooks';

const useStyles = makeStyles((theme) => ({
  nested: {
    paddingLeft: theme.spacing(6),
  },
  loginScreenButton: {
    backgroundColor: 'rgba(47,46,46,0.4)',
  },
}));

export const MenuList = () => {
  const classes = useStyles();
  const { match } = useReactRouter();
  const navigate = useNavigator();
  const [open, onToggle] = useMenuState();
  const { user } = useUser();
  const userse = ['/admin/managers', '/admin/superManagers', '/admin/trainers'];
  const structure = [
    '/admin/clubs',
    '/admin/athletes',
    '/admin/gyms',
    '/admin/groups',
  ];
  const functional = [
    '/admin/certifications',
    '/admin/contributions',
    '/admin/statistics',
  ];
  const handleClick = (section) => {
    onToggle(section);
  };

  return (
    <div>
      <ListItem button onClick={() => navigate('/cabinet')}>
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary={t`Головна`} />
      </ListItem>
      <ListItem button onClick={() => handleClick(SECTION_MAP.users)}>
        <ListItemIcon>
          <PeopleIcon />
        </ListItemIcon>
        <ListItemText primary={t`Користувачі`} />
        {open[SECTION_MAP.users] ? <ExpandLess /> : <ExpandMore />}
      </ListItem>

      <Collapse
        in={open[SECTION_MAP.users] || userse.includes(match.url)}
        timeout='auto'
        unmountOnExit
      >
        <List component='div' disablePadding className={classes.nested}>
          <ListItem
            className={
              match.url === '/admin/permissions'
                ? classes.loginScreenButton
                : ''
            }
            button
            onClick={() => navigate(router.admin.permissions.list())}
          >
            <ListItemText primary={t`Доступи`} />
          </ListItem>
          <ListItem
            className={
              match.url === '/admin/superManagers'
                ? classes.loginScreenButton
                : ''
            }
            button
            onClick={() => navigate(router.admin.superManagers.list())}
          >
            <ListItemText primary={t`Менеджери клубів`} />
          </ListItem>
          <ListItem
            className={
              match.url === '/admin/managers' ? classes.loginScreenButton : ''
            }
            button
            onClick={() => navigate(router.admin.managers.list())}
          >
            <ListItemText primary={t`Адміністратори клубів`} />
          </ListItem>
          <ListItem
            className={
              match.url === '/admin/trainers' ? classes.loginScreenButton : ''
            }
            button
            onClick={() => navigate(router.admin.trainers.list())}
          >
            <ListItemText primary={t`Тренери`} />
          </ListItem>
        </List>
      </Collapse>
      <ListItem button onClick={() => handleClick(SECTION_MAP.structure)}>
        <ListItemIcon>
          <AccountTreeIcon />
        </ListItemIcon>
        <ListItemText primary={t`Структура`} />
        {open[SECTION_MAP.structure] ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={open[SECTION_MAP.structure] || structure.includes(match.url)}
        timeout='auto'
        unmountOnExit
      >
        <List component='div' disablePadding className={classes.nested}>
          <ListItem
            className={
              match.url === '/admin/clubs' ? classes.loginScreenButton : ''
            }
            button
            onClick={() => navigate(router.admin.clubs.list())}
          >
            <ListItemText primary={t`Клуби`} />
          </ListItem>
          <ListItem
            className={
              match.url === '/admin/athletes' ? classes.loginScreenButton : ''
            }
            button
            onClick={() => navigate(router.admin.athletes.list())}
          >
            <ListItemText primary={t`Спортсмени`} />
          </ListItem>
          <ListItem
            className={
              match.url === '/admin/gyms' ? classes.loginScreenButton : ''
            }
            button
            onClick={() => navigate(router.admin.gyms.list())}
          >
            <ListItemText primary={t`Зали`} />
          </ListItem>
          <ListItem
            className={
              match.url === '/admin/groups' ? classes.loginScreenButton : ''
            }
            button
            onClick={() => navigate(router.admin.groups.list())}
          >
            <ListItemText primary={t`Группи`} />
          </ListItem>
        </List>
      </Collapse>
      <ListItem button onClick={() => handleClick(SECTION_MAP.functional)}>
        <ListItemIcon>
          <AppsIcon />
        </ListItemIcon>
        <ListItemText primary={t`Функціонал`} />
        {open[SECTION_MAP.functional] ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse
        in={open[SECTION_MAP.functional] || functional.includes(match.url)}
        timeout='auto'
        unmountOnExit
      >
        <List component='div' disablePadding className={classes.nested}>
          <ListItem
            className={
              match.url === '/admin/certifications'
                ? classes.loginScreenButton
                : ''
            }
            button
            onClick={() => navigate(router.admin.certifications.list())}
          >
            <ListItemText primary={t`Атестації`} />
          </ListItem>
          {canViewContributions(user) && (
            <ListItem
              className={
                match.url === '/admin/contributions'
                  ? classes.loginScreenButton
                  : ''
              }
              button
              onClick={() => navigate(router.admin.contributions.list())}
            >
              <ListItemText primary={t`Членскі внески`} />
            </ListItem>
          )}
          <ListItem
            className={
              match.url === '/admin/statistics' ? classes.loginScreenButton : ''
            }
            button
            onClick={() => navigate('/admin/statistics')}
          >
            <ListItemText primary={t`Статистика`} />
          </ListItem>
        </List>
      </Collapse>
      {canViewDankai(user) && (
        <ListItem
          className={
            match.url === '/admin/dankai' ? classes.loginScreenButton : ''
          }
          button
          onClick={() => navigate('/admin/dankai')}>
          <ListItemIcon>
            <LocalLibraryIcon />
          </ListItemIcon>
          <ListItemText primary={t`Данкай`} />
        </ListItem>
      )}
    </div>
  );
};

export default MenuList;
